<template>
  <v-footer class="section fp-auto-height">
    <v-container>
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <section>
            <div class="logo">
              <span class="d-sr-only">FINBRIDGE</span>
            </div>
            <div class="d-flex flex-wrap">
              <dl>
                <dt>대표</dt>
                <dd>민홍준</dd>
              </dl>
              <dl>
                <dd>서울시 마포구 독막로3길 45, 5층(서교동, DSM Square) 04044</dd>
              </dl>
              <dl>
                <dt>대표전화</dt>
                <dd>1688-4102</dd>
              </dl>
              <dl>
                <dt>통신판매업</dt>
                <dd>2022-서울마포-2057</dd>
              </dl>
              <dl>
                <dt>사업자등록번호</dt>
                <dd class="mr-2">719-86-01150</dd>
              </dl>
              <dl>
                <dd>
                  <v-btn class="mr-2" color="primary" depressed rounded x-small v-bind="privacyLink">
                    개인정보처리방침
                    <v-icon right small class="ml-0">mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-btn class="mr-2" color="grey lighten-3" depressed rounded x-small @click="open">
                    사업자정보확인
                    <v-icon right small class="ml-0">mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-btn color="primary" depressed rounded x-small href="mailto:help@finbridge.co.kr">고객문의</v-btn>
                  <v-btn class="ml-2" color="primary" depressed rounded x-small href="mailto:hj.min@finbridge.co.kr">제휴문의</v-btn>
                </dd>
              </dl>
            </div>
            <p class="copylight">&copy;FINBRIDGE Co., Ltd. All rights reserved.</p>
          </section>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { FB_HOMEPAGE_URL, isSafeguardHost } from "@/assets/js/safeguardSite";

export default {
  name: "MainFooter",
  computed: {
    // 세이프가드 홈페이지에서는 핀브릿지 홈페이지의 개인정보처리방침을 새 창으로 연다
    privacyLink() {
      if (!isSafeguardHost()) {
        return { to: { name: "Privacy" } };
      }
      return {
        href: FB_HOMEPAGE_URL + this.$router.resolve({ name: "Privacy" }).href,
        target: "_blank",
        rel: "noopener noreferrer"
      };
    }
  },
  methods: {
    open() {
      window.open("http://www.ftc.go.kr/bizCommPop.do?wrkr_no=7198601150", "title", "width=750,height=700");
    }
  }
};
</script>

<style lang="scss" scoped>
footer {
  background-color: #F7F9FA !important;
  padding: 16px 0 !important;
  font-size: 11px;
  .logo {
    width: 72px;
    height: 10.3px;
    background: url("~@/assets/new/logo_wordmark_b.svg") no-repeat 0 0;
    background-size: contain;
    margin-bottom: 16px;
  }
  section {
    margin: 0 auto;
    padding: 0 18px;
    dl {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      &:nth-child(-n+4) {
        &:after {
          content: "";
          display: flex;
          opacity: 0.25;
          margin: 0 6px;
        }
      }
      dt {
        margin-right: 4px;
      }
      dd {
        font-weight: 600;
        letter-spacing: -0.5px;
        .v-btn {
          font-size: 11px;
          .v-icon.v-icon {
            padding-top: 1px;
          }
        }
      }
    }
    .copylight {
      margin-top: 8px;
      font-size: 10px;
      opacity: 0.75;
    }
  }

  @include respond-to("small") {
    font-size: 12px;
    .logo {
      width: 91px;
      height: 13px;
    }
    section {
      padding: 0 30px;
    }
  }

  @include respond-to("medium") {
    font-size: 12px;
    .logo {
      width: 91px;
      height: 13px;
    }
    section {
      padding: 0;
      dl {
        &:nth-child(-n+4) {
          &:after {
            content: "|";
            margin: 0 8px;
          }
        }
      }
      .copylight {
        margin-top: 0;
        font-size: 11px;
      }
    }
  }
}
</style>